import { Flex, MenuButtonProps } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import React, { useCallback, useEffect } from 'react';
import {
  ISelectDropdownOption,
  SelectDropdown,
} from '~/components/SelectDropdown';
import { allowedSortDirections, allowedSortFields } from '~/searchApi';

import { sortOptions } from './SortCreatorsDropDownConstants';

interface SortCreatorsDropDownProps extends MenuButtonProps {
  sortField: allowedSortFields;
  sortDirection: allowedSortDirections;
  setSortingOrder: (
    field: allowedSortFields,
    direction: allowedSortDirections,
  ) => void;
}

export const SortCreatorsDropDown: React.FC<SortCreatorsDropDownProps> = ({
  sortField,
  sortDirection,
  setSortingOrder,
  ...menuButtonProps
}) => {
  const getSelectDropDownOptions: (
    excludedValues: string[],
  ) => ISelectDropdownOption[] = (excludedValues) => {
    return sortOptions
      .filter(({ value }) => !excludedValues.includes(value))
      .map(({ friendlyValue, icon: Icon, ...rest }) => ({
        ...rest,
        friendlyValue,
        render: (isSelected) => (
          <Flex
            alignItems="center"
            data-testid="dropdown-option"
            fontWeight={isSelected ? 500 : 'normal'}
          >
            <Icon marginRight="2" boxSize={4} />
            {friendlyValue}
          </Flex>
        ),
      }));
  };

  const defaultValue = `${sortField}:${sortDirection}`;

  const router = useRouter();
  const { sortBy } = router.query as { sortBy: string };

  useEffect(() => {
    if (!sortBy) return;
    const [field, directionOrPlatform] = sortBy.split(':');

    setSortingOrder(
      field as allowedSortFields,
      directionOrPlatform as allowedSortDirections,
    );
  }, [sortBy, setSortingOrder]);

  const onValChange = useCallback(
    (value: string) => {
      router.replace({
        query: {
          ...router.query,
          sortBy: value,
        },
      });
    },
    [router],
  );

  const options = getSelectDropDownOptions([]);

  return (
    <SelectDropdown
      menuButtonProps={{
        fontSize: { md: 'md' },
        paddingX: '4',
        height: '10',
        ...menuButtonProps,
      }}
      menuListProps={{
        paddingY: '1',
        marginY: '1',
      }}
      menuItemOptionProps={{
        paddingY: '1',
        width: 60,
      }}
      defaultValue={sortBy || defaultValue}
      itemPrefix="Sort by"
      onChange={onValChange}
      options={options}
      selectedPrefix="Sort by"
      trackId="foam-myagency-stack-sortbybutton"
    />
  );
};
